import baseTheme from '../baseTheme';
var MuiTooltip = {
    /* your custom class style overrides here */
    tooltip: {
        backgroundColor: baseTheme.palette.common.white,
        color: baseTheme.palette.text.primary,
        fontSize: baseTheme.typography.body1.fontSize,
        padding: baseTheme.spacing(1) + " " + baseTheme.spacing(2),
        border: "1px solid " + baseTheme.palette.grey[300],
        borderRadius: '5px',
        boxShadow: baseTheme.shadows[2],
    },
};
export default MuiTooltip;
//# sourceMappingURL=MuiTooltip.js.map